<script setup>
const userStore = useUserStore();
const { isUserProfileDialogOpen, viewedUserProfile, userProfileLoading } =
  storeToRefs(userStore);

const handleDialogModelChange = (value) => {
  if (!value) {
    userStore.closeUserProfileDialog();
  }
};
</script>

<template>
  <v-dialog
    v-model="isUserProfileDialogOpen"
    class="tw-rounded-2xl !tw-z-[2010]"
    width="540"
    persistent
    scrim="#000"
    opacity="0.5"
    @update:model-value="handleDialogModelChange"
  >
    <v-btn
      icon
      color="transparent"
      flat
      density="compact"
      :ripple="false"
      class="tw-absolute tw-top-2 tw-right-2 tw-z-[1]"
      @click="userStore.closeUserProfileDialog"
    >
      <v-icon size="32" icon="mdi-close-circle-outline"> </v-icon>
    </v-btn>

    <profile-block
      :userInfo="viewedUserProfile"
      :loading="userProfileLoading"
      @onRequestSuccess="userStore.fetchViewedUserProfile"
      @onOpenRoom="userStore.closeUserProfileDialog"
    />
  </v-dialog>
</template>
